import {
    request,
    requestPublic
} from './request.js'

export function getBackgroundImageList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/FocusFigure/BackgroundImageList',
        method: 'get',
        params: {
            Title: obj.title,
            PageIndex: obj.pageIndex,
            PageSize: obj.pageSize,
        }
    })
}

//添加
export function addBackgroundImage(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/FocusFigure/AddBackgroundImage',
        method: 'post',
        data: data
    })
}

//编辑
export function editBackgroundImage(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/FocusFigure/EditBackgroundImage',
        method: 'post',
        data: data
    })
}
//批量删除
export function deletesBackgroundImage(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/FocusFigure/DeleteFocusFigure',
        method: 'post',
        data: data
    })
}